import { z } from "zod";
import RefurbishmentResults from "@/pages/RefurbishmentResults";
import type { ModuleProps } from "../types";

export const resultsSummaryConfig = z.object({});
export type ResultsSummaryConfig = z.infer<typeof resultsSummaryConfig>;

export function ResultsSummaryModule(_props: ModuleProps<ResultsSummaryConfig>) {
  return <RefurbishmentResults />;
}
